import icon0 from './beginn schiessuebungsraum.png';
import icon1 from './beginn schiessuebungsstrecke.png';
import icon2 from './doppelrhombus.png';
import icon3 from './doppelwinkel.png';
import icon4 from './ende schiessuebungsraum.png';
import icon5 from './ende schiessuebungsstrecke.png';
import icon6 from './rhombus.png';
import icon7 from './stellung feuerhalt.png';
import icon8 from './winkel.png';

const textures = {
  'beginn schiessuebungsraum': icon0,
  'beginn schiessuebungsstrecke': icon1,
  'doppelrhombus': icon2,
  'doppelwinkel': icon3,
  'ende schiessuebungsraum': icon4,
  'ende schiessuebungsstrecke': icon5,
  'rhombus': icon6,
  'stellung feuerhalt': icon7,
  'winkel': icon8,
};

export default textures;